import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { Singleton } from '../../../../core/services/Singleton';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _HealthAttentionCause, _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthLOINC, _HealthProduct, _HealthTechnologyType, _MedicalDevice, _TriageType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const HealthLOINCEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_HealthLOINC)
    const [id, setID] = useState(null);
    const single = Singleton.getInstance();
    const [type, setType] = useState<any>(null)
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Paraclínico/Ayuda Diagnóstica", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDHealthLOINC == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getHealthLOINCCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDHealthLOINC', visible: true },
        { title: 'LOINC', property: 'LOINC_NUM', visible: true },
        { title: 'Nombre Común', property: 'LONG_COMMON_NAME', visible: true },
        { title: 'Nombre Corto', property: 'SHORTNAME', visible: true },
        { title: 'Componente', property: 'COMPONENT', visible: true },
        { title: 'Propiedad', property: 'PROPERTY', visible: true },
        { title: 'Tiempo', property: 'TIME_ASPCT', visible: true },
        { title: 'Sistema', property: 'SYSTEM', visible: true },
        { title: 'Escala', property: 'SCALE_TYP', visible: true },
        { title: 'Método', property: 'METHOD_TYP', visible: true },
        { title: 'Clase', property: 'CLASS', visible: true },
        { title: 'Tipo', property: 'CHNG_TYPE', visible: true },
        { title: 'Ejemplo Unidades UCUM', property: 'EXAMPLE_UCUM_UNITS', visible: true },
        { title: 'Orden/Observaciones', property: 'ORDER_OBS', visible: true },
        { title: 'Primera Versión', property: 'VersionFirstReleased', visible: true },
        { title: 'Última Versión', property: 'VersionLastChanged', visible: true },
        { title: 'Ranking', property: 'COMMON_TEST_RANK', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Paraclínico/Ayuda Diagnóstica"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDHealthLOINC); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}